/* import React from "react";

import api from '../../services/api';
import "./style.css";

import Home from "../Home";
import dodoImage from "../../assets/img/dodo_02.png";

import { Link } from 'react-router-dom';
const Login= () => {
  

  return (
	<div class="join-container-login-form">
	<div class="join-container-login">
		<header class="join-header-login">
		<img
            className="chatWindow--avatar"
            src={Dodo}
            alt="dodo"
          />

		</header>
		<main class="join-main-login">
			<form action="" >
				<div class="form-control">
					<label for="e-mail"></label>
					<input
						type="text"
						name="email"
						id="email"
						placeholder="email..."
						required
					/>
				</div>
				<div class="form-control">
					<label for="room"></label>
					<input
						type="text"
						name="PassWord"
						id="passWord"
						placeholder="Enter password..."
						required
					/>
				</div>
			
				<Link to={"/Home"}>	<button  type="" class="btn-login"> Login</button>	</Link>
				
				<p>Don have an account 
					<a href="#"> Sing up</a>
				</p>
							
			</form>
		</main>
	</div>
	</div>
  );
};
export default Login;


 */



import React, {useState} from 'react';
import { Link, useNavigate} from 'react-router-dom';
import{ FiLogIn } from 'react-icons/fi';

import api from '../../services/api';

import './style.css';

import logoImage from '../../assets/img/logo.png';

export default function Login(){
    const[id, setId] = useState('');
    const[password, setPassword] = useState('');
    
    const navigate = useNavigate();

    async function handleLogin(error){
        error.preventDefault();
        try{
            const response = await api.post('login', {id});
            //console.log(response.data.name);
            //guardar o id da Ong para uso porterior
            //localStorage.setItem('ongId', id);
            //localStorage.setItem('ongName', response.data.name);

            navigate('/profile');
        }catch (err){
            alert("Falha no login, tente novamente");

        } 

    }

    return(
        <div className = "login-container">
            <section className="form">
                <img src={logoImage} alt=" Dodo"/>

                <form onSubmit={handleLogin}>
                    <h1>Faça o seu login</h1>

                    <input 
                        type='email'
                        placeholder="Seu email" 
                        value={id}
                        onChange={error => setId(error.target.value)}
                    />

                    <input 
                        type='password'
                        placeholder="Sua senha" 
                        value={password}
                        onChange={error => setPassword(error.target.value)}
                    />

                    <Link to={"/home"}>	
                        <button className = "button" type="submit">Entrar</button>	
                    </Link>

                    <Link className="back-link" to={"/registar"}>
                        <FiLogIn size={16} color="#1ABC9C" />
                        Não Tenho Cadastro
                    </Link>
                </form>
            </section>            
        </div>
    );
}